import { replaceFamilyTokens } from '../utils/replace-family-tokens';
import { replaceFaqTokens } from '../utils/replace-faq-tokens';
import { replaceGroupTokens } from '../utils/replace-group-tokens';
import { replaceVideoTokens } from '../utils/replace-video-tokens';
var originalHtmlProperty = 'original-html';
var replaceTokens = function ($element, group) {
    var html = $element.prop(originalHtmlProperty);
    var augmentedHtml = replaceFaqTokens(html, group);
    augmentedHtml = replaceVideoTokens(augmentedHtml, group);
    augmentedHtml = replaceGroupTokens(augmentedHtml, group);
    augmentedHtml = replaceFamilyTokens(augmentedHtml, group);
    $element.html(augmentedHtml);
};
export var ReplaceTokensDirective = [
    'productContextService',
    function (productContextService) {
        return {
            link: function ($scope, $element) {
                $element.prop(originalHtmlProperty, $scope.ngModel || $element.html());
                if (productContextService.getContext()) {
                    replaceTokens($element, productContextService.getContext());
                }
                productContextService.subscribe()
                    .then(null, null, function (group) {
                    replaceTokens($element, group);
                });
            },
            restrict: 'E',
            scope: {
                ngModel: '=',
            },
        };
    },
];
